export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'お問い合わせ',
      description: 'まずはお気軽にご連絡ください',
      details: [
        'メール: info@example.com',
        '受付時間: 平日9:00-18:00'
      ],
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: 'ヒアリング',
      description: 'メールで会社の状況についてお尋ねします',
      details: [
        '法人の資料をご準備いただけると助かります',
        'お手続きの流れについてご説明いたします'
      ],
      icon: 'ri-question-answer-line'
    },
    {
      number: '03',
      title: '売却方法・条件の決定',
      description: '最適な売却方法と条件を決定します',
      details: [
        '委託販売（仲介）または直接買取',
        '売却価格の設定'
      ],
      icon: 'ri-file-list-3-line'
    },
    {
      number: '04',
      title: '販売開始',
      description: 'WEBページへ掲載し、買い手を募集します',
      details: [
        '匿名での掲載も可能',
        '購入希望者からの問い合わせ対応'
      ],
      icon: 'ri-global-line'
    },
    {
      number: '05',
      title: '購入希望者との交渉',
      description: '購入希望者から申込みがあり次第、ご連絡します',
      details: [
        '条件面での調整',
        '必要書類の確認'
      ],
      icon: 'ri-discuss-line'
    },
    {
      number: '06',
      title: 'ご契約',
      description: 'ご契約書をお送りし、譲渡手続きへ進みます',
      details: [
        '譲渡契約書の締結',
        '印鑑類・代金の預託'
      ],
      icon: 'ri-file-text-line'
    },
    {
      number: '07',
      title: '決済・お引渡し',
      description: '代表者変更完了後、売買代金の決済とお引渡し',
      details: [
        '登記変更の実施',
        '売買代金のお支払い',
        '法人物品のお引渡し'
      ],
      icon: 'ri-check-double-line'
    }
  ];

  return (
    <section id="process" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-teal-50 rounded-full mb-6">
            <i className="ri-route-line text-teal-600 text-xl mr-3"></i>
            <span className="text-sm font-bold text-teal-600">PROCESS</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            会社売却の<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">流れ</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            お問い合わせから成約まで、安心してお任せいただけるよう<br />
            丁寧にサポートいたします
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-teal-500 via-cyan-500 to-teal-500 transform -translate-x-1/2"></div>

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className={`flex flex-col lg:flex-row items-center gap-8 ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                {/* Content */}
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                  <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
                    <div className={`flex items-center gap-4 mb-4 ${index % 2 === 0 ? 'lg:justify-end' : 'lg:justify-start'}`}>
                      <span className="text-5xl font-black bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">
                        {step.number}
                      </span>
                      <h3 className="text-2xl font-black text-gray-900">{step.title}</h3>
                    </div>
                    <p className="text-base text-gray-700 mb-4 font-bold">{step.description}</p>
                    <ul className="space-y-2">
                      {step.details.map((detail, idx) => (
                        <li key={idx} className={`flex items-start gap-2 text-sm text-gray-600 ${index % 2 === 0 ? 'lg:justify-end' : 'lg:justify-start'}`}>
                          <i className="ri-checkbox-circle-fill text-teal-500 mt-1 flex-shrink-0"></i>
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Icon */}
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center shadow-xl shadow-teal-500/30 transform hover:scale-110 transition-transform duration-300">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                </div>

                {/* Spacer */}
                <div className="flex-1 hidden lg:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
